//import config from "../config/config";

export default function ApiClient(uri, options = {}) {
  options.headers = {
    'Accept': 'application/json',
    //'Content-Type': 'application/json',
    ...options.headers
  };
  // const url = config.apiBaseUrl + uri;
  const url = uri;
  return fetch(url, options).then(res => {

    if(res.status >= 200 && res.status < 300){
      return res.json().then(json => {
        return json;
      });
    } else {
      return res.json().then(json => {
        console.error('api error', json)
        return Promise.reject(json);
      });   
    }
  });
}
